import { useEffect } from "react";
import useGetData from "../../../../CustomHooks/useAxios/useGetData";
import { mapRoles } from "../../../../utils/roles";
import { GET_USER_ROLES } from "../../apiEndpoints";
import { UserInfoBoxTitle, UserBoxWrapper } from "./UserDialogUi";

const UserRoles = ({ userId }) => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(GET_USER_ROLES + userId);
  }, [userId]);

  return (
    <UserBoxWrapper>
      <UserInfoBoxTitle title="User Roles" />
      {/* Loading State */}
      {!isLoaded && <p className="px-3 py-2 text-blue-500">Loading roles...</p>}

      {/* Error State */}
      {error && (
        <p className="px-3 py-2 text-red-500 text-sm">
          {error || "Failed to load user roles"}
        </p>
      )}

      {/* Roles List */}
      {isLoaded && !error && data?.length > 0
        ? data.map((role, ind) => (
            <p
              key={ind}
              className="px-2 py-1 bg-gray-100 my-2 mx-3 rounded-md max-lg:text-sm text-[15px] hover:bg-blue-100"
            >
              {mapRoles[role] || role}
            </p>
          ))
        : isLoaded &&
          !error && (
            <p className="px-3 py-2 text-gray-500">No roles assigned.</p>
          )}
    </UserBoxWrapper>
  );
};

export default UserRoles;
